import { FieldProps } from '~components/form-fields';

import FormInputActualTimes from '../../components/FormInputActualTimes';
import FormInputDistanceTravelled from '../../components/FormInputDistanceTravelled';
import FormInputSignature from '../../components/FormInputSignature';
import FormInputTimeMarked from '../../components/FormInputTimeMarked';
import FormInputTravelTime from '../../components/FormInputTravelTime';
import FormInputVehicleType from '../../components/FormInputVehicleType';
import {
  deriveActualTimes,
  deriveDistanceTravelled,
  deriveReadOnlyDate,
  deriveTimeMarked,
  readOnlyRepeatDates,
  readOnlyRepeatFrequency,
} from '../../lib/derive';
import { showAppointmentDateOrLess, showTimeMarked } from '../../lib/show';
import { commonFields } from './common';

const appointmentActiveCommonFields: FieldProps = {
  ...commonFields,
  client_package_name: {
    type: 'readonly',
    caption: 'Default Package',
    field: 'client.default_package.name',
    className: 'text-left',
    order: 220,
  },
  time_marked: {
    type: 'custom',
    caption: 'Time Marked',
    labelCaption: 'Auto marked by the system',
    colSize: 6,
    component: FormInputTimeMarked,
    order: 1110,
    deriveValue: deriveTimeMarked,
    show: showTimeMarked,
  },
  distance_travelled: {
    type: 'custom',
    caption: 'Distance Travelled',
    labelCaption: 'Entered by the care worker',
    colSize: 6,
    component: FormInputDistanceTravelled,
    deriveValue: deriveDistanceTravelled,
    show: showAppointmentDateOrLess,
    order: 1120,
  },
  travel_1: {
    type: 'custom',
    caption: 'Time Travelled (TO Client)',
    labelCaption: 'Entered by the care worker',
    component: FormInputTravelTime,
    colSize: 6,
    order: 1130,
    show: showAppointmentDateOrLess,
  },
  vehicle_type: {
    type: 'custom',
    caption: 'Vehicle Type',
    labelCaption: 'Entered by the care worker',
    component: FormInputVehicleType,
    colSize: 6,
    order: 1140,
    show: showAppointmentDateOrLess,
    options: [
      { id: 'user', name: 'My Car (Care Worker)' },
      { id: 'company', name: 'Company' },
    ],
  },
  actual_times: {
    type: 'custom',
    caption: 'Actual Times Entered',
    labelCaption: 'Entered by the care worker',
    component: FormInputActualTimes,
    deriveValue: deriveActualTimes,
    colSize: 6,
    order: 1150,
    show: showAppointmentDateOrLess,
  },
  signature: {
    type: 'custom',
    caption: 'Client Signature',
    component: FormInputSignature,
    order: 1160,
  },
};

const appointmentSingleActiveFields: FieldProps = {
  ...appointmentActiveCommonFields,
  date: {
    type: 'readonly',
    caption: 'Appointment Date',
    deriveValue: deriveReadOnlyDate,
    order: 120,
  },
};

const appointmentRepeatActiveFields: FieldProps = {
  ...appointmentActiveCommonFields,
  repeat_dates: {
    type: 'multi-readonly',
    caption: 'Repeat Dates',
    deriveValue: readOnlyRepeatDates,
    order: 120,
  },
  repeat_frequency: {
    type: 'multi-readonly',
    caption: 'Frequency',
    deriveValue: readOnlyRepeatFrequency,
    order: 130,
  },
};

export { appointmentSingleActiveFields, appointmentRepeatActiveFields };
